// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPresetConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get POPUP_HEADER() {
    return localizer.getText('DASHBOARD_PRESET_CONSTANT_POPUP_HEADER');
  },
  get POPUP_TEXT() {
    return localizer.getText('DASHBOARD_PRESET_CONSTANT_POPUP_TEXT');
  },
  get OPTIONS() {
    return [
      {
        tooltip: localizer.getText('DASHBOARD_PRESET_CONSTANT_BLANK_DASHBOARD'),
        icon: 'icon-layout-01 u_hidden',
        tiles: []
      },
      {
        tooltip: localizer.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_ONE_TITLE_PER_ROW'),
        icon: 'icon-layout-01',
        tiles: [
          { positionX: 0, positionY: 0, width: 12, height: 4 },
          { positionX: 0, positionY: 4, width: 12, height: 4 }
        ]
      },
      {
        tooltip: localizer.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_TWO_TITLES_ON_FIRST_ROW'),
        icon: 'icon-layout-02',
        tiles: [
          { positionX: 0, positionY: 0, width: 6, height: 4 },
          { positionX: 6, positionY: 0, width: 6, height: 4 },
          { positionX: 0, positionY: 4, width: 12, height: 4 }
        ]
      },
      {
        tooltip: localizer.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_TWO_TITLES_PER_ROW'),
        icon: 'icon-layout-03',
        tiles: [
          { positionX: 0, positionY: 0, width: 6, height: 4 },
          { positionX: 6, positionY: 0, width: 6, height: 4 },
          { positionX: 0, positionY: 4, width: 6, height: 4 },
          { positionX: 6, positionY: 4, width: 6, height: 4 }
        ]
      },
      {
        tooltip: localizer.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_THREE_TITLES_PER_ROW'),
        icon: 'icon-layout-04',
        tiles: [
          { positionX: 0, positionY: 0, width: 4, height: 4 },
          { positionX: 4, positionY: 0, width: 4, height: 4 },
          { positionX: 8, positionY: 0, width: 4, height: 4 },
          { positionX: 0, positionY: 4, width: 4, height: 4 },
          { positionX: 4, positionY: 4, width: 4, height: 4 },
          { positionX: 8, positionY: 4, width: 4, height: 4 }
        ]
      },
      {
        tooltip: localizer.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_ONE_TITLE_FIRST_ROW'),
        icon: 'icon-layout-05',
        tiles: [
          { positionX: 0, positionY: 0, width: 12, height: 4 },
          { positionX: 0, positionY: 4, width: 6, height: 4 },
          { positionX: 6, positionY: 4, width: 6, height: 4 }
        ]
      },
      {
        tooltip: localizer.getText('DASHBOARD_PRESET_CONSTANT_THREE_ROW_ONE_TITLE_PER_ROW'),
        icon: 'icon-layout-06',
        tiles: [
          { positionX: 0, positionY: 0, width: 12, height: 4 },
          { positionX: 0, positionY: 4, width: 12, height: 4 },
          { positionX: 0, positionY: 8, width: 12, height: 4 }
        ]
      },
      {
        tooltip: localizer.getText('DASHBOARD_PRESET_CONSTANT_THREE_ROW_TWO_TITLES_PER_ROW'),
        icon: 'icon-layout-07',
        tiles: [
          { positionX: 0, positionY: 0, width: 6, height: 4 },
          { positionX: 6, positionY: 0, width: 6, height: 4 },
          { positionX: 0, positionY: 4, width: 6, height: 4 },
          { positionX: 6, positionY: 4, width: 6, height: 4 },
          { positionX: 0, positionY: 8, width: 6, height: 4 },
          { positionX: 6, positionY: 8, width: 6, height: 4 }
        ]
      },
      {
        tooltip: localizer.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_TWO_ON_FIRST_THREE_ON_SECOND'),
        icon: 'icon-layout-08',
        tiles: [
          { positionX: 0, positionY: 0, width: 6, height: 4 },
          { positionX: 6, positionY: 0, width: 6, height: 4 },
          { positionX: 0, positionY: 4, width: 4, height: 4 },
          { positionX: 4, positionY: 4, width: 4, height: 4 },
          { positionX: 8, positionY: 4, width: 4, height: 4 }
        ]
      },
      {
        tooltip: localizer.getText(
          'DASHBOARD_PRESET_CONSTANT_THREE_ROW_ONE_TITLE_ON_FIRST_ROW_TWO_ON_SECOND_ONE_ON_THIRD'
        ),
        icon: 'icon-layout-09',
        tiles: [
          { positionX: 0, positionY: 0, width: 12, height: 4 },
          { positionX: 0, positionY: 4, width: 6, height: 4 },
          { positionX: 6, positionY: 4, width: 6, height: 4 },
          { positionX: 0, positionY: 8, width: 12, height: 4 }
        ]
      },
      {
        tooltip: localizer.getText(
          'DASHBOARD_PRESET_CONSTANT_THREE_ROW_ONE_TITLE_ON_FIRST_ROW_TWO_ON_SECOND_THREE_ON_THIRD'
        ),
        icon: 'icon-layout-10',
        tiles: [
          { positionX: 0, positionY: 0, width: 12, height: 4 },
          { positionX: 0, positionY: 4, width: 6, height: 4 },
          { positionX: 6, positionY: 4, width: 6, height: 4 },
          { positionX: 0, positionY: 8, width: 4, height: 4 },
          { positionX: 4, positionY: 8, width: 4, height: 4 },
          { positionX: 8, positionY: 8, width: 4, height: 4 }
        ]
      },
      {
        tooltip: localizer.getText(
          'DASHBOARD_PRESET_CONSTANT_THREE_ROW_ONE_TITLE_ON_FIRST_ROW_THREE_ON_SECOND_ONE_ON_THIRD'
        ),
        icon: 'icon-layout-11',
        tiles: [
          { positionX: 0, positionY: 0, width: 12, height: 4 },
          { positionX: 0, positionY: 4, width: 4, height: 4 },
          { positionX: 4, positionY: 4, width: 4, height: 4 },
          { positionX: 8, positionY: 4, width: 4, height: 4 },
          { positionX: 0, positionY: 8, width: 12, height: 4 }
        ]
      }
    ];
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.DashboardPresetConstants.js